module.exports = __webpack_public_path__ + "img/uploaded-doc.c5472f05.svg";